import { ICITScheduledAccountNumbers } from "@/Settings/types/Common/model";

const resolveCitScheduledAccountNumbers = (citScheduledAccountNumbers?: ICITScheduledAccountNumbers[], values?: { label: string }[]) => {
	const contractsInTransit =
		citScheduledAccountNumbers
			?.find((item) => item.label === "Contracts in Transit")
			?.values?.map((item) => ({
				label: item,
				hasOptions: false,
				order: 0,
			})) || [];
	const financeReservesReceivables =
		citScheduledAccountNumbers
			?.find((item) => item.label === "Finance Reserves Receivables")
			?.values?.map((item) => ({
				label: item,
				hasOptions: false,
				order: 0,
			})) || [];
	const stringValues = values?.map((item) => item.label) || [];
	return [...contractsInTransit, ...financeReservesReceivables].filter((item) => !stringValues.includes(item.label));
};

export default resolveCitScheduledAccountNumbers;
